import {
  EnergyContract,
  EnergyContractProductType,
  EnergyContractState,
} from '../model/energyContract.model'

export function getProductNameForEnergyContract(energyContract: EnergyContract) {
  switch (energyContract.productType) {
    case EnergyContractProductType.ELECTRICITY:
      return 'Electricidad'
    default:
      return 'Producto desconocido'
  }
}

export function getStateNameForEnergyContract(energyContract: EnergyContract) {
  switch (energyContract.state) {
    case EnergyContractState.DRAFT:
      return 'En vuelo'
    case EnergyContractState.ACTIVE:
      return 'Activo'
    case EnergyContractState.DISMISSED:
      return 'Cancelado'
    case EnergyContractState.TERMINATED:
      return 'Baja'
    default:
      return '-'
  }
}
